import { Directive, ElementRef, Optional } from '@angular/core';
import { FormControlName } from '@angular/forms';

@Directive({
  selector: '[formControlName]',
})
export class FormControlExceptionDirective {

  private messageMap: { [key: string]: string };

  constructor(
    private element: ElementRef,
    @Optional() private formControl: FormControlName
  ) {
    this.messageMap = {
      default: 'Valor inválido',
      invalid: 'Valor inválido',
      not_num: 'Número inválido',
      required: 'Campo obrigatório',
      length: 'Quantidade de caracteres inválida',
      minlength: 'Quantidade de caracteres inválida',
      maxlength: 'Quantidade de caracteres inválida',
      cpf: 'CPF inválido',
      cnpj: 'CNPJ inválido',
      invalid_date: 'Data inválida',
      invalid_hour: 'Hora inválida',
      invalid_cep: 'CEP inválido',
      invalid_uf: 'UF inválida',
      invalid_municipio: 'Município inválido',
      invalid_tel: 'Número de telefone inválido',
      max_date: 'Data início não pode ser maior que data fim',
      invalid_date_more_1_year: 'O ano de não pode ser maior que ' + (new Date().getFullYear() + 1),
      tipo_marcacao: 'Selecione o tipo',
      nome: 'Deve iniciar com letras e conter mais de 2 caracteres',
      email: 'E-mail inválido',
      url: 'Url inválida',
      lattes: 'Lattes iD inválido',
      confirmarEmail: 'E-mail não é igual',
      dataBetween: 'Data não pode ser menor'
    };
  }

  ngOnInit() {
    const matFormField = (this.element.nativeElement.nodeName).toLowerCase() == 'quill-editor' ?
      this.element.nativeElement : this.element.nativeElement.parentNode.parentNode;
    let messageNode;

    if (matFormField.nextElementSibling && matFormField.nextElementSibling.classList) {
      const classList = matFormField.nextElementSibling.classList;
      if (classList.value && classList.value.indexOf('form-control-exception') > -1) {
        messageNode = matFormField.nextElementSibling;
      } else if (classList.contains('form-control-exception')) {
        messageNode = matFormField.nextElementSibling;
      } else {
        messageNode = this.addMessageNode(matFormField);
      }
    } else {
      messageNode = this.addMessageNode(matFormField);
    }

    this.formControl.statusChanges.subscribe((status) => {
      if (!messageNode) {
        return;
      }
      if (status === 'INVALID') {
        Object.keys(this.formControl.errors).forEach((key) => {
          messageNode.innerText = this.messageMap.hasOwnProperty(key) ? this.messageMap[key] : this.messageMap.default;
        });
        messageNode.classList.remove('hide');
        this.colorirVermeho(matFormField);
      } else {
        setTimeout(() => messageNode.innerText = '', 800);
        messageNode.classList.add('hide');
        this.removerVermelho(matFormField);
      }
    });

    this.formControl.formDirective.ngSubmit.subscribe(() => {
    });
  }


  private removerVermelho(matFormField) {
    if ((matFormField.nodeName).toLowerCase() == 'quill-editor') {
      matFormField.firstChild.style.border = '';
      matFormField.children[1].style.border = '';
    } else {
      matFormField.children[0].style.color = '';
    }
  }

  private colorirVermeho(matFormField) {
    if ((matFormField.nodeName).toLowerCase() == 'quill-editor') {
      matFormField.firstChild.style.border = 'solid red 1px';
      matFormField.children[1].style.border = 'solid red 1px';
    } else {
      matFormField.children[0].style.color = 'red';
    }
  }

  private addMessageNode(matFormField) {
    const messageNode = document.createElement('mat-error');
    messageNode.classList.add('mat-error');
    messageNode.classList.add('hide');
    if (matFormField.insertAdjacentElement) {
      matFormField.insertAdjacentElement('afterend', messageNode);
    } else {
      matFormField.after(messageNode);
    }

    return messageNode;
  }
}
